/**
 * to weight as number
 * @param v
 * @param n
 * @return {number}
 */
export const toWeight = (v, n) => {
  let value = 0;
  if (n !== 0) {
    value = (100 * v) / n;
    value = Math.round(value * 10) / 10;
  }
  return value;
};

/**
 * to weight as str
 * @param v
 * @param n
 * @return {string}
 */
export const toWeightStr = (v, n) => {
  if(v === null || n === null) return "";
  return `${toWeight(v, n)} %`;
};

export const toUnit = (v, unit, n) => {
  if (unit === "kcm") {
    return toKCMStr(v, n);
  }

  return v;
};

/**
 *
 * @param x
 * @param n (to get the same unit when v/n)
 * @return {string}
 */
function numberWithSpace(x, n) {
  //x = x/1000 || 0;
  //x = Math.round(x*10)/10;
  n = n || x;
  let unit = "cm";

  if(n < 99){
    unit = "cm"
  } else if (n >= 100 && n < 99999){
    x = x/100 || 0;
    x = Math.round(x*100)/100;

    unit = "m"
  } else if (n >= 100000){
    x = x/100000 || 0;
    x = Math.round(x*100)/100;
    unit = "km"
  }
    x = x || 0;
  return x.toLocaleString()+unit
}

const toKCMStr = (v = 0, n=0) => {
  return numberWithSpace(v, n)
};



// WEBPACK FOOTER //
// src/modules/stats/summary/format.js